import RouteName from '@/models/enums/RouteName'
import CRMPermission from '@/models/enums/permissions/CRMPermission'

export default [
  {
    path: '/knowledge-base',
    name: RouteName.KnowledgeBase,
    component: () => import('@/pages/KnowledgeBase/Index'),
    meta: {
      breadcrumb: {
        label: 'База знаний',
        parent: 'Главная',
      },
    },
  },
  {
    path: '/knowledge-base/downloads',
    name: RouteName.KnowledgeBaseDownloads,
    component: () => import('@/pages/KnowledgeBase/Downloads'),
    meta: {
      breadcrumb: {
        label: 'Загрузки',
        parent: RouteName.KnowledgeBase,
      },
    },
  },
  {
    path: '/knowledge-base/filial-connection',
    name: RouteName.KnowledgeBaseFilialConnection,
    component: () => import('@/pages/KnowledgeBase/FilialConnection'),
    meta: {
      permissions: [CRMPermission.KnowledgeBaseFilialConnection],
      breadcrumb: {
        label: 'Подключение филиала к ФАКТ',
        parent: RouteName.KnowledgeBase,
      },
    },
  },
]
